<template>
  <div class="attendance-overview m_b8">
    <!-- 打卡数据 -->
    <ul class="sign-record p_b8" v-if="signList.length">
      <li class="sign-item m_r8 m_t8" v-for="(item,index) in signList" :key="index">
        <p v-for="(i,j) in item" :key="j">
          <xin-icon xin-type="map-pin-check-fill" :class="i.clockTime ? 'sk-text' : ''" />
          <span>{{ i.rangeName||"" }}{{ i.clockTime }}</span>
          <span
            v-if="i.statusDesc"
            class="color-label color-err"
          >
            {{ i.statusDesc }}
          </span>
          <span v-if="i.statusDesc && canSignApply" @click="handlerSignAgain(i)" class="m_l8 c_pointer sk-text">{{$xinI18n('补卡','ApproveV2-approveNameEmun-sign')}}</span>
        </p>
      </li>
    </ul>

    <!-- 假勤、审批、旷工 -->
    <ul class="holiday-flow-list color-label p_t8 f_s12" v-if="statusList.length || flowList.length">
      <li v-for="(item,index) in statusList" :key="index" class="m_b8">
        <span :class="{'color-err':item.statusName==$xinI18n('旷工','ApproveV2-AttendanceCount-kuanggong')}">{{ item.statusName }}</span>
        <span class=""> {{ item.timeUnit == 0 ? getDayDetail(item) : item.hours + $xinI18n('小时','Common-xiaoshis') }}</span>
        <span class="">（{{ getDayNum(item.salaryDay) }}{{$xinI18n('天','Common-tians')}}）</span>
        <span v-if="item.startTime != 0 && item.endTime != 0 && item.timeUnit!=0">{{ getTime(item.startTime) + " " + "~" }}{{ getTime(item.endTime) }}</span>
        <span
          v-if="item.isAbnormal == 1 && canSignApply"
          class="c_pointer sk-text"
          @click="handlerSignAgain(i)"
        >{{$xinI18n('补卡','ApproveV2-approveNameEmun-sign')}}
        </span>
      </li>
      <li class="flow">
        <div
          v-for="item in flowList"
          :key="item.flowSid"
          @click="gotoBdkFlow(item)"
          class="flow-item m_b8 c_pointer"
          :title="$xinI18n('点击跳转详情', 'home-attendance-go-to-detail')"
        >
          <span class="">{{ item.flowTypeName }}</span>
          <span class="">{{ getBdkTime(item) }}</span>
          <span class="status" :class="{'cancle':item.isFinish === -1}">
            {{ item.isFinish === -1 ? $xinI18n('审批取消', 'ApproveV2-DayDetail-getLeaveMessage-shenpiquxiao') : $xinI18n('审批中','ApproveV2-shenpizhong')}}
          </span>
        </div>
      </li>
    </ul>

    <!-- 外勤 -->
    <ul class="out-side f_s12 p_t8 p_b8" v-if="outSideTypeList.length">
      <li class="" v-for="(item,index) in outSideTypeList" :key="index">
        <span class="">{{$xinI18n('外勤', 'OutsidePunch-componentDidMount-title-waiqin')}}</span>
        <span class="">{{ outsideTypeMap[item] }}（{{['1','0.5','0.5'][item]}}{{$xinI18n('天','Common-tians')}}）</span>
      </li>
    </ul>

    <!-- 月异常统计数据 -->
    <div v-if="showMounthAbnormal" class="mounth-abnormal p_t8 p_b8">
      <span class="color-label">{{$xinI18n('本月异常','home-benyueyichang')}}：</span>
      <span v-if="attendanceStatistics.lateNum" class="abnormal-item m_r8">{{$xinI18n('迟到','ApproveV2-AttendanceCount-chidao')}} {{attendanceStatistics.lateNum}}</span>
      <span v-if="attendanceStatistics.leaveEarlyNum" class="abnormal-item m_r8">{{$xinI18n('早退','ApproveV2-AttendanceCount-zaotui')}} {{attendanceStatistics.leaveEarlyNum}}</span>
      <span v-if="attendanceStatistics.absentNum" class="abnormal-item">{{$xinI18n('旷工','ApproveV2-AttendanceCount-kuanggong')}} {{attendanceStatistics.absentNum}}</span>
    </div>
  </div>
</template>

<script lang="ts">
  import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
  import moment from 'moment'

  @Component({})
  export default class AttendanceOverview extends Vue {

    //审批列表
    @Prop({default:()=>[]})
    applyList!:any

    @Prop({default:()=>({})})
    currentRecordData!:any

    //考勤异常数据
    @Prop({default:()=>({})})
    attendanceStatistics!:any

    //是否开启补打卡
    isOpenSignApply = false
    //补打卡审批数据，审批理性，ID等
    signApplyData:any = {}
    bukaLoading = false
    outsideTypeMap = {
      0: this.$xinI18n('全天', 'DateRange-label-quantian'),
      1: this.$xinI18n('上半天', 'DateRange-label-shangbantian'),
      2: this.$xinI18n('下半天', 'DateRange-label-xiabantian'),
    }

    //是否是今天
    get isToday(){
      return this.currentRecordData.isToday
    }

    get isFinish(){
      return this.currentRecordData.detailInfo ? this.currentRecordData.detailInfo.isFinish : 0
    }
    //月异常统计数据
    get showMounthAbnormal(){
      const { lateNum, leaveEarlyNum, absentNum } = this.attendanceStatistics
      return lateNum>0 || leaveEarlyNum>0 || absentNum>0
    }
    //打卡列表
    get signList(){
      const list = []
      const signTimeListAll = this.currentRecordData.detailInfo ? this.currentRecordData.detailInfo.signTimeList : []
      const signTimeList = signTimeListAll.filter((i:any)=>[1,2].includes(i.clockAttribution))
      for(let i=0; i< signTimeList.length; i++){
        if(i % 2 == 0){
          list.push([
            signTimeList[i],
            signTimeList[i+1]
          ])
        }
      }
      return list
    }
    //异常考勤列表
    get statusList(){
      return this.currentRecordData.detailInfo ? this.currentRecordData.detailInfo.statusList : []
    }
    //审批详情列表
    get flowList(){
      return this.currentRecordData.detailInfo ? this.currentRecordData.detailInfo.flowList||[] : []
    }
    //外勤列表
    get outSideTypeList(){
      return this.currentRecordData.detailInfo ? this.currentRecordData.detailInfo.outSideTypeList : []
    }

    //补卡审批开启 && 不是今天 && 不是未来时间不是入职之前
    get canSignApply(){
      return this.isOpenSignApply && !this.isToday && this.isFinish !=2
    }

    @Watch("applyList", { deep: true, immediate:true })
    watchApplyList() {
      this.isOpenSignApply = false;
      this.applyList.forEach((v:any) => {
        if (v.groupId == 2) {
          let baseApplyList = v.baseApplyList;
          let isOpenSignApply = baseApplyList.some((item: any) => {
            if (item.flow_type === "6") {
              this.signApplyData = item;
            }
            return item.flow_type === "6";
          });
          this.isOpenSignApply = isOpenSignApply;
        }
      });
    }

    getBdkTime(bdkItem: any) {
      let dayData = this.currentRecordData;
      const dayDataRealDay = new Date(dayData.time * 1000);
      const bdkItemRealDay = new Date(bdkItem.startDate * 1000);
      let dayDataRealDayStr =
        dayDataRealDay.getFullYear() +
        "" +
        this.fillZero(dayDataRealDay.getMonth()) +
        "" +
        this.fillZero(dayDataRealDay.getDate());
      let bdkItemRealDayStr =
        bdkItemRealDay.getFullYear() +
        "" +
        this.fillZero(bdkItemRealDay.getMonth()) +
        "" +
        this.fillZero(bdkItemRealDay.getDate());
      if (bdkItemRealDayStr != dayDataRealDayStr) {
        return (
          this.fillZero(bdkItemRealDay.getMonth() + 1) +
          "-" +
          this.fillZero(bdkItemRealDay.getDate()) +
          " " +
          this.fillZero(new Date(bdkItem.startDate * 1000).getHours()) +
          ":" +
          this.fillZero(new Date(bdkItem.startDate * 1000).getMinutes())
        );
      }
      return (
        this.fillZero(new Date(bdkItem.startDate * 1000).getHours()) +
        ":" +
        this.fillZero(new Date(bdkItem.startDate * 1000).getMinutes())
      );
    }
    fillZero(num: number) {
      return num >= 10 ? num : "0" + num;
    }
    // 返回上半天/下半天/全天文案
    getDayDetail(item: any) {
      let dayDetail = "";
      if (item.morningOrAfternoon == 0) {
        dayDetail = this.$xinI18n("上半天", 'DateRange-label-shangbantian');
      } else if (item.morningOrAfternoon == 1) {
        dayDetail = this.$xinI18n("下半天", 'DateRange-label-xiabantian');
      } else {
        dayDetail = this.$xinI18n("全天", 'DateRange-label-quantian');
      }
      return dayDetail;
    }
    // 返回天数
    getDayNum(salaryDay: any) {
      let salaryDayNum = salaryDay + "";
      return salaryDayNum.substring(0, salaryDayNum.lastIndexOf(".") + 3);
    }
    //获取HH:mm
    getTime (time:number) {
      return moment(time*1000).format('HH:mm')
    }

    // 点击补卡按钮
    handlerSignAgain(item: any) {
      if(this.bukaLoading) return

      this.bukaLoading = true;
      const { time } = this.currentRecordData;
      const fetchData = { date: time };
      this.$http({
        url: "/employee-pc/service/attendance/ajax-bdk-sign-check",
        method: "POST",
        data: fetchData,
      })
        .then((res: any) => {
          this.bukaLoading = false;
          if (!res.data.status) {
            this.$message.error(res.data.message);
          } else {
            this.jumpToSignAgain(item);
          }
        })
        .catch((err: any) => {
          this.bukaLoading = false;
        });
    }

    //可以补签，跳补签页
    jumpToSignAgain(item?: any) {

      this.XrxsTracker.$track('a_homeClickCalendarSchedule','','approve-bk')

      const { time } = this.currentRecordData;
      const { flow_type, flow_setting_id, flow_group_id } = this.signApplyData;
      let jumpPath = "/staff/approve/apply-form";
      const sid= item ? item.rangeId : -1
      const type= item ? item.clockAttribution : -1
      if (time) {
        //@ts-ignore
        jumpPath = jumpPath + `?bdkDate=${time}&id=${sid}&type=${type}&flowType=${flow_type}&flowSettingId=${flow_setting_id}&flowGroupId=${flow_group_id}`;
        window.location.href = jumpPath
      }
    }

    // 跳转申请页
    gotoBdkFlow(item: any) {

      this.XrxsTracker.$track('a_homeClickCalendarSchedule','','approve-detail')

      window.location.href = `/staff/approve/detail?sid=${item.flowSid}&currentTab=myApply&isPrevOrNext=0`
    }
  }
</script>

<style lang="scss" scoped>
.attendance-overview{
  overflow: hidden;
  padding: 0 8px;
  background: #f4fafc;
  border-radius: 4px;

  .sign-record{
    box-sizing: content-box;
    display: flex;
    min-height: 40px;
    flex-wrap: wrap;
    .sign-item{
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      min-width: 25%;
      &::before{
        content: '';
        position: absolute;
        left: 7px;
        top: 10px;
        height: 20px;
        border-left: var(--xs-border-color-primary) 1px dashed;
      }
      p{
        z-index: 1;
        .xin-icon{
          color: var(--xs-border-color-spec);
        }
        span{
          font-size: 12px;
        }
      }
    }
  }

  .holiday-flow-list{
    .kuanggong{

    }
    .flow{
      display: flex;
      flex-wrap: wrap;
      .flow-item{
        margin-right: 24px;
        display: flex;
        align-items: center;
        .status{
          margin-left: 8px;
          padding: 0 8px;
          height: 20px;
          line-height: 20px;
          background: #FFF7E7;
          border-radius: 10px;
          &.cancle{
            background: #F0F0F0;
          }
        }
      }
    }
  }

  .mounth-abnormal{
    border-top: 1px var(--xs-border-color-primary) dashed;
    font-size: 12px;
    .abnormal-item{
      color: #FEA631;
      font-family: D-DIN;
    }
  }
}
</style>
